import { MemberDetailsResponse } from "@/api/members.api";
import { MemberProfile } from "./MemberProfile";
import { MemberStats } from "./MemberStats";

interface MemberProfileSectionProps {
  memberDetails: MemberDetailsResponse;
}

export function MemberProfileSection({
  memberDetails,
}: MemberProfileSectionProps) {
  return (
    <div>
      <MemberProfile
        member={memberDetails.member}
        totalVisits={memberDetails.totalVisits}
        lastVisitDate={memberDetails.lastVisitDate}
      />

      <MemberStats
        lifetimeSpend={memberDetails.lifetimeSpend}
        lifetimeTip={memberDetails.lifetimeTip}
        currency={memberDetails.currency}
      />
    </div>
  );
} 